import { render } from "./TemplateCollectionFrames.vue?vue&type=template&id=055a3bcb&scoped=true"
import script from "./TemplateCollectionFrames.vue?vue&type=script&lang=js"
export * from "./TemplateCollectionFrames.vue?vue&type=script&lang=js"

import "./templateCollectionFrames.scss?vue&type=style&index=0&id=055a3bcb&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055a3bcb"]])

export default __exports__